
import GenreMaker from '../anychart/genreMaker'; 

var PyramidChart = class PyramidChart extends GenreMaker {

    setData(state){
        console.log("entry pyramid");
        super.setData(state);
        var subGenre = this.getSubGenre();

        this.chart = anychart.pyramid(this.data);
        return this.chart;
    }

    createChart(){
        return null;
    }; 
};


    
GenreMaker.pyramid = PyramidChart;

export var PyramidChart;



// WEBPACK FOOTER //
// ./src/anychart/pyramidChart.js